import { PartnerConfig } from '@/types'
import { baseConfig } from '../Centene/missouriHomeStateHealthV2'

const agentHshConfig: PartnerConfig = {
  ...baseConfig,
  config: {
    ...baseConfig.config,
    codes: {
      membership: 'B360HSHWEB',
    },
    partnerUrlSlug: 'agent-hsh',
  },
}

const agentHshConfigWithDnaV2Design: PartnerConfig = {
  ...agentHshConfig,
  config: {
    ...agentHshConfig.config,
    useDnaV2Design: true,
  },
}

export default [agentHshConfig, agentHshConfigWithDnaV2Design]
